import AppService from '@/services/app.service'
import QcCampaignService from "@/services/qc.campaign.service";
import {QCCampaignActionTypes} from '@/store/actionTypes'
import userStore from "@/store/modules/user/user.store";
import $filters from "@/modules/fptai/filters/filters";
import CampaignService from '@/services/campaign.service'

const types = QCCampaignActionTypes

const state = {
    campaign: null,
    isEdit: false,
    indexCall: 0,
    totalCall: 0,
    batch: null,
    dataInputSuggestion: null,
    reportMetrics: [],
    callCampaigns: []
}

const mutations = {
    [types.UPDATE_CAMPAIGN]: (state, campaign) => {
        state.campaign = campaign
    },
    [types.IS_EDIT]: (state, boolean) => {
        state.isEdit = !!(boolean)
    },
    [types.SET_INDEX_CALL]: (state, indexCall) => {
        state.indexCall = indexCall
    },
    [types.SET_TOTAL_CALL]: (state, totalCall) => {
        state.totalCall = totalCall
    },
    [types.UPDATE_BATCH]: (state, batch) => {
        state.batch = batch
    },
    [types.UPDATE_ASR_CRITERIA]: (state, asrCriteria) => {
        state.campaign.asr_criteria = asrCriteria
    },
    [types.UPDATE_CRITERIA]: (state, criteria) => {
        state.campaign.criteria = criteria
    },
    [types.DATA_INPUT_SUGGESTION]: (state, dataInputSuggestion) => {
        state.dataInputSuggestion = dataInputSuggestion
    },
    [types.UPDATE_DATA_INPUT]: (state, dataInput) => {
        state.campaign.data_input = dataInput
    },
    [types.REPORT_METRICS]: (state, reportMetrics) => {
        state.reportMetrics = reportMetrics
    },
    [types.CALL_CAMPAIGNS]: (state, callCampaigns) => {
        state.callCampaigns = callCampaigns
    },
}

const actions = {
    [types.UPDATE_CAMPAIGN]({commit}, {campaign, model}) {
        return new Promise((resolve, reject) => {
            if (!campaign && !model) {
                commit(types.UPDATE_CAMPAIGN, null)
                reject()
            }

            let promise
            if (campaign) {
                if (!campaign.created_by || campaign.created_by === '') {
                    campaign.created_by = userStore.state.profile.email
                }
                promise = QcCampaignService.updateQCCampaign(campaign, model)
            } else {
                if (!model.created_by || model.created_by === '') {
                    model.created_by = userStore.state.profile.email
                }

                promise = QcCampaignService.createQCCampaign(model)
            }

            const action = campaign ? $filters.tc('update') : $filters.tc('create')
            promise.then(result => {
                commit(types.UPDATE_CAMPAIGN, result.data)
                AppService.toastSuccess($filters.tc('actionSuccessful', {
                    action,
                    item: window.vueapp.$t('campaign')
                }))
                resolve(result.data)
            }, err => {
                commit(types.UPDATE_CAMPAIGN, false)
                AppService.handleRequestError($filters.tc('actionFailed', {
                    action,
                    item: window.vueapp.$t('campaign')
                }))
                reject(err)
            })
        })
    },
    [types.UPDATE_CALL_CAMPAIGNS]({commit}) {
        return CampaignService.getCampaigns(1000).then(result => {
            const callCampaigns = result.data ? result.data.data.filter(i => i.permissions.includes("admin")) : []
            commit(types.CALL_CAMPAIGNS, callCampaigns)
        })
    },
    [types.SET_DATA]({commit}, data) {
        return new Promise(resolve => {
            commit(types.UPDATE_CAMPAIGN, data)
            resolve()
        })
    },
    [types.IS_EDIT]({commit}, boolean) {
        commit(types.IS_EDIT, boolean)
    },
    [types.DATA_INPUT_SUGGESTION]({commit}, callCampaignID) {
        let dataInputSuggestion = {}
        QcCampaignService.getDataInputSuggestion(callCampaignID).then(result => {
            dataInputSuggestion["data_collection"] = result.data["data_collection"]
            dataInputSuggestion["customer_properties"] = result.data["customer_properties"]
            dataInputSuggestion["system"] = result.data["system_config"]
            dataInputSuggestion["nlp"] = result.data["nlp"]
        })

        return new Promise(resolve => {
            commit(types.DATA_INPUT_SUGGESTION, dataInputSuggestion)
            resolve()
        })
    },
    [types.GET_REPORT_METRICS]({commit}, qcCampaignID) {
        return QcCampaignService.ReportMetricService.search(qcCampaignID).then(result => {
            commit(types.REPORT_METRICS, result.data)
        });
    },
    [types.CREATE_REPORT_METRIC]({dispatch}, data) {
        return QcCampaignService.ReportMetricService.create(data.qcCampaignID, data.model)
    },
    [types.UPDATE_REPORT_METRIC]({dispatch}, data) {
        return QcCampaignService.ReportMetricService.update(data.qcCampaignID, data.reportMetricId, data.model)
    },
    [types.DELETE_REPORT_METRIC]({dispatch}, data) {
        return QcCampaignService.ReportMetricService.delete(data.qcCampaignID, data.reportMetricId)
    },
    [types.SWAP_REPORT_METRIC]({dispatch}, data) {
        return QcCampaignService.swapReportMetric(data.qcCampaignID, data.model)
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
